import { useQuery } from '@tanstack/react-query'

import { simulacaoKeys } from '@/features/simulador/brasil/utils/queries'
import { GetSimulacoesRelacionadas } from '@/features/simulador/shared/http/get-simulacoes-relacionadas.service'

export const useSimulacoesRelacionadas = (idSimulacaoPrincipal: string) => {
  return useQuery({
    queryKey: simulacaoKeys.listaSimulacoesRelacionadas(idSimulacaoPrincipal),
    queryFn: async () => new GetSimulacoesRelacionadas().execute(idSimulacaoPrincipal).then((res) => res.data),
    gcTime: 0,
    enabled: false,
  })
}
